const alertLogin = () => {
  // eslint-disable-next-line no-alert
  alert('로그인이 필요합니다.');
};

export default alertLogin;
